import { OperationSupportService } from "@/service/OperationSupportService";
import { OperationSupportLog } from "@/types/OperationSupport";
import { reactive, ref } from "vue";

export function useOperationSupportLog() {
  const srv = new OperationSupportService()

  /**
   * 任意のログをDBに記録します
   * 運用支援ログはサーバーで検知できない動作などを記録するために使用されます
   * 例）モバイルアプリの動作／クライアント側での特定の挙動etc...
   */
  const saveLog = async (logData: OperationSupportLog) => {
    await srv.saveLog(logData)
  }
  return {
    saveLog
  }
}
